<template>
  <header v-bind:class="['main-header', image === null ? 'without-image' : '', image]">
    <router-link v-if="back && back.label" :to="{ name: back.href, params: back.params, query: back.query}"><Icon name="arrow_back"/><span class="onglet">{{ back.label }}</span></router-link>
    <h1 v-if="title" class="title">{{ title }}</h1>
    <Navigation v-if="navigation && navigation.length > 0" v-bind:actions="navigation" />
  </header>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Navigation from '@/components/generics/Navigation.vue'
import NavigationItem from '@/lib/transfer-objects/NavigationItem.js'
export default {
  computed: {
    ...mapGetters('header', ['title', 'image', 'back', 'navigation'])
  },
  methods: {
    ...mapActions('header', ['setHeaderBack'])
  },
  watch: {
    $route (to, from) {
      if (to.meta && to.meta.breadcrumb) {
        if (Array.isArray(to.meta.breadcrumb) && this.$_.find(to.meta.breadcrumb, {'name': from.name})) {
          var target = this.$_.find(to.meta.breadcrumb, {'name': from.name})
          this.setHeaderBack({back: new NavigationItem({label: target.text, href: target.name, params: from.params})})
        } else if (to.meta.breadcrumb.name) {
          if (from.name === 'SiteList') {
            this.setHeaderBack({back: new NavigationItem({label: to.meta.breadcrumb.text, href: to.meta.breadcrumb.name, params: from.params, query: from.query})})
          } else {
            this.setHeaderBack({back: new NavigationItem({label: to.meta.breadcrumb.text, href: to.meta.breadcrumb.name, params: from.params})})
          }
        }
      } else {
        this.setHeaderBack({})
      }
    }
  },
  components: {
    Navigation
  }
}
</script>

<style lang="sass">
@import './static/sass/variables.sass'

.main-header
  width: 100%
  min-height: max-content
  background-color: $white
  display: block
  padding: 2rem 0 1.875rem 2rem
  box-sizing: border-box
  background-repeat: no-repeat
  background-position: 0% bottom
  background-size: auto 160px

  .title
    font-weight: bold
    margin: 0
    color: $black

  @media screen and (max-width: map-get($grid-breakpoints, 's'))
    .title
        font-size: 1rem
  @media screen and (min-width: map-get($grid-breakpoints, 'm'))
      .title
          font-size: 1.5rem
  @media screen and (min-width: map-get($grid-breakpoints, 'l'))
      .title
          font-size: 2.5rem

  .priorities
    float: right
    position: relative
    margin-right: 8rem
    display: block
    margin-top: 2rem


    label
      display: block
      text-transform: uppercase
      font-size: 0.6875rem
      font-weight: bold
      margin-bottom: 9px

    input
      position: relative
      cursor: pointer
      appearance: none
      border: none
      outline: none
      position: absolute
      width: 24px
      height: 24px
      border-radius: 50%

      &:checked
        &:before
          content: "\e5ca"
          font-family: $font-icon
          color: $white
          margin-left: 0.4rem
          font-size: 0.7rem
          margin-top: 0.3rem
          position: absolute

  .high
    background-color: $color-high
    margin-left: 0

  .medium
    background-color: $color-medium
    margin-left: 2rem

  .low
    background-color: $color-low
    margin-left: 4rem

  .good
    background-color: $color-good
    margin-left: 6rem

  .search-bar
    float: right
    margin-right: 7rem
    margin-top: 2rem

    input
      vertical-align: middle
      border: 1px solid rgba($black, 0.2)
      border-radius: 3px
      padding-left: 1.25rem
      height: 2.625rem
      width: 15.625rem
      align-items: center
      outline: none
      -webkit-appearance: none
      -moz-appearance: none
      font-size: 0.75rem

  .search-icon
    display: inline-block
    margin-left: -2.5rem
    appearance: none
    border: none
    cursor: pointer
    outline: none
    background-color: transparent

    .material-icons
      font-size: 1.5rem

  .boolean
    position: relative
    float: right
    margin-top: 2rem
    margin-right: 5rem
    display: block
    text-transform: uppercase
    font-size: 0.6875rem
    font-weight: bold

  .bar
    width: 36px
    height: 12px
    margin-top: 9px
    border-radius: 100px
    background-color: rgba($grey-light, 0.2)

  #boolean
    margin-top: 9px
    display: block
    cursor: pointer
    appearance: none
    border: none
    outline: none
    width: 20px
    height: 20px
    position: absolute
    margin-top: -0.3rem
    border-radius: 50%
    background-color: $blue-active
    box-shadow: 1px 2px 4px 0 rgba($black, .2)
    &:checked
      margin-left: 1rem
      background-color: $grey-panel

  a
    text-decoration: none

  button
    appearance: none
    background-color: transparent
    border: none
    outline: none
    cursor: pointer
    padding: 0
    margin-bottom: 0.3125rem

  .material-icons
    font-size: 0.825rem
    vertical-align: middle

  .onglet
    text-transform: uppercase
    font-size: 0.75rem
    color: rgba($black, 0.54)
    margin-left: 0.625rem

  .subtitle
    margin-left: 1.5rem
    font-size: 2.5rem
    font-weight: bold

.energy-control
  background-color: rgba($black, .1)
  margin: 0
  height: auto
  position: relative
  margin-right: 2rem
  display: block
  float: right
  margin-top: 2rem
  border-radius: 100px

  ul
    display: inline
    width: 100%
    margin: 0
    padding: 0
    line-height: 3rem

  .energy
    box-sizing: border-box
    display: inline
    position: relative
    line-height: 2rem
    border-radius: 100px
    a
      border-radius: 100px
      padding: 1.01rem 2.21rem
      vertical-align: 5%
      font-size: 0.8125rem
      font-weight: bold
      color: $blue-active
      transition: background-color, color

      &:hover
        background-color: $blue-active
        color: $white
        transition-duration: 0.5s, 0.2s
    .active
      background-color: $blue-active
      color: $white

.without-image
  padding: 1.875rem 0 1.875rem 3rem

  .title
    min-width: 50%


</style>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue